"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useStakingStats = void 0;
var react_1 = require("react");
var web3_utils_1 = require("web3-utils");
var _contracts_1 = require("../../contracts");
var _launchpadConstants_1 = require("../../launchpadConstants");
var _shared_1 = require("../../shared");
var utils_1 = require("../../shared/utils");
var utils_2 = require("../../staking/utils");
function useStakingStats(_a) {
    var stakingContract = _a.stakingContract, pairContract = _a.pairContract, isPair = _a.isPair, decimals = _a.decimals, pool = _a.pool;
    var web3 = (0, _shared_1.useWeb3Provider)().web3;
    var rewardTokenContract = (0, _contracts_1.useERC20)(pool.rewardToken.address, web3);
    var rewardTokenPrice = (0, _shared_1.usePriceFetcher)({
        priceRefresher: pool.rewardToken.priceRefresher,
    });
    var stakingTokenPriceFetcher = (0, react_1.useMemo)(function () {
        return isPair
            ? function () {
                return (0, utils_2.getLpTokenPrice)({
                    pairContract: pairContract,
                    tokenPriceInUsd: rewardTokenPrice,
                    getCurrencyPriceInUsd: pool.stakeToken[1].priceRefresher,
                    tokenDecimals: pool.stakeToken[0].decimals,
                });
            }
            : pool.stakeToken.priceRefresher;
    }, [pairContract, rewardTokenPrice, isPair]);
    var stakingTokenPrice = (0, _shared_1.usePriceFetcher)({
        priceRefresher: stakingTokenPriceFetcher,
    });
    var _b = (0, react_1.useState)(_launchpadConstants_1.ZERO_BN), totalStaked = _b[0], setTotalStaked = _b[1];
    var _c = (0, react_1.useState)(_launchpadConstants_1.ZERO_BN), rewardPerBlock = _c[0], setRewardPerBlock = _c[1];
    var _d = (0, react_1.useState)(_launchpadConstants_1.ZERO_BN), rewardsLeft = _d[0], setRewardsLeft = _d[1];
    var _e = (0, react_1.useState)(0), apr = _e[0], setApr = _e[1];
    var refresh = (0, react_1.useCallback)(function () {
        if (!pairContract || !stakingContract)
            return;
        (0, utils_1.call)(pairContract, 'balanceOf', [
            (pool === null || pool === void 0 ? void 0 : pool.balanceAddress) || stakingContract.options.address,
        ])
            .then(web3_utils_1.toBN)
            .then(function (v) { return setTotalStaked((0, utils_1.normalizeDecimals)(v, decimals)); });
        (0, utils_1.call)(stakingContract, 'rewardPerBlock')
            .then(web3_utils_1.toBN)
            .then(function (v) {
            return setRewardPerBlock((0, utils_1.normalizeDecimals)(v, pool.rewardToken.decimals));
        });
        getRewardsLeft({ rewardTokenContract: rewardTokenContract, stakingContract: stakingContract })
            .then(function (v) { return (0, utils_1.normalizeDecimals)(v, pool.rewardToken.decimals); })
            .then(setRewardsLeft);
    }, [pairContract, stakingContract]);
    (0, react_1.useEffect)(function () {
        refresh();
        var id = setInterval(refresh, 5 * 60 * 1000);
        return function () { return clearInterval(id); };
    }, [refresh]);
    (0, react_1.useEffect)(function () {
        if (!stakingTokenPrice)
            return;
        var totalStakedN = (0, utils_1.toEthN)(totalStaked);
        var apr = (0, utils_1.getApr)(stakingTokenPrice, rewardTokenPrice, totalStakedN, (0, utils_1.toEthN)(rewardPerBlock));
        // debug("pool APR", pool.title, {
        //   apr,
        //   stakingTokenPrice,
        //   rewardTokenPrice,
        //   totalStakedN,
        //   rewardPerBlock: toEthN(rewardPerBlock),
        // });
        setApr(apr);
    }, [stakingTokenPrice, rewardTokenPrice, totalStaked, rewardPerBlock]);
    return {
        stakingTokenPrice: stakingTokenPrice,
        rewardTokenPrice: rewardTokenPrice,
        totalStaked: totalStaked,
        rewardPerBlock: rewardPerBlock,
        rewardsLeft: rewardsLeft,
        apr: apr,
        refresh: refresh,
    };
}
exports.useStakingStats = useStakingStats;
function getRewardsLeft(_a) {
    var rewardTokenContract = _a.rewardTokenContract, stakingContract = _a.stakingContract;
    return __awaiter(this, void 0, void 0, function () {
        var treasury, e_1;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _b.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, (0, utils_1.call)(stakingContract, 'treasury')];
                case 1:
                    treasury = _b.sent();
                    return [3 /*break*/, 3];
                case 2:
                    e_1 = _b.sent();
                    treasury = stakingContract.options.address;
                    return [3 /*break*/, 3];
                case 3:
                    if (!treasury) {
                        return [2 /*return*/, _launchpadConstants_1.ZERO_BN];
                    }
                    return [4 /*yield*/, (0, utils_1.call)(rewardTokenContract, 'balanceOf', [treasury]).then(web3_utils_1.toBN)];
                case 4: return [2 /*return*/, _b.sent()];
            }
        });
    });
}
